import api from '../../api'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            date:'',
            solde:[]
        }
        state.all.forEach(element => {    
            //console.log('mon roles ', element.created_at)       
            row = {
                date : element.date,   
                solde : element.solde,   
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setaccount(state, accounts) {
        state.all = accounts
    },
    adduser(state,user){
        state.all.push(user)
    }
}

const actions={
    async get_all_account({ commit }){
        return api.charts.get_all_account().then((response)=>{
            commit('setaccount', response.data.data)
            //console.log("mes montants ",response.data.data)
            return response.data.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
